// Google Ads (gtag.js). The base tag (script + dataLayer/gtag bootstrap, AW-18517302080) is in public/index.html <head> on every route;
// this file fires the events: one page_view per public route change, a conversion on lead/quote/contact form submit and on tel: clicks.
// Conversions and page_views stay PUBLIC-site only (never the admin app /app, the portal or admin Fortune tools).
// send_to values come from the frontend .env: REACT_APP_GADS_SEND_TO_FORM / _PHONE (full "AW-…/label"), else the older label-only keys.

const TAG_ID = "AW-18517302080";
const sendTo = (full, label) => (full && full.trim()) || (label && label.trim() ? `${TAG_ID}/${label.trim()}` : "");

export const GOOGLE_ADS = Object.freeze({
  tagId: TAG_ID,
  conversions: {
    form: sendTo(process.env.REACT_APP_GADS_SEND_TO_FORM, process.env.REACT_APP_GADS_FORM_CONVERSION_LABEL),   // lead / quote / contact / demo / trial form submitted
    phone: sendTo(process.env.REACT_APP_GADS_SEND_TO_PHONE, process.env.REACT_APP_GADS_PHONE_CONVERSION_LABEL), // tel: link or phone button clicked
  },
  value: 1.0,
  currency: "USD",
});

const PRIVATE_PATH = /^\/(app|portal|preview)(\/|$)|^\/fortune\/(inquiries|map|broadcast|flyer|social)(\/|$)/;
export const isPublicPath = (pathname) => !PRIVATE_PATH.test(pathname || "/");

const gtag = (...args) => {
  try { if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag(...args); } catch { /* tag offline */ }
};

let loaded = false;
// The <head> bootstrap in index.html already loaded gtag.js and sent config (= first page_view). Only if it is missing (e.g. a stripped
// HTML shell) append the script + bootstrap here, once.
export function loadGoogleAds() {
  if (loaded || typeof window === "undefined" || typeof document === "undefined") return;
  loaded = true;
  if (typeof window.gtag === "function" && document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS.tagId}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS.tagId); // sends the first page_view itself
}

// SPA page_view: the first public route loads the tag (config = first page_view); later route changes send a page_view event.
let lastView = { path: null, at: 0 };
export function gadsPageView(pathname, search = "") {
  if (!isPublicPath(pathname)) return;
  const path = `${pathname}${search || ""}`;
  const now = Date.now();
  if (path === lastView.path && now - lastView.at < 1000) return; // StrictMode double effect / double mount
  const first = !loaded;
  lastView = { path, at: now };
  if (first) { loadGoogleAds(); return; }
  gtag("event", "page_view", { send_to: GOOGLE_ADS.tagId, page_path: path, page_location: window.location.href, page_title: document.title });
}

function conversion(kind) {
  const to = GOOGLE_ADS.conversions[kind];
  if (!to) return false;
  if (!loaded) loadGoogleAds();
  gtag("event", "conversion", { send_to: to, value: GOOGLE_ADS.value, currency: GOOGLE_ADS.currency });
  return true;
}

// Call once, after the server confirmed a public lead / quote / contact / demo / trial form submission.
export const gadsLead = () => conversion("form");

// Any click on a tel: link anywhere on a public page (delegated, installed once by RouteMeta).
let phoneListener = false;
let lastPhoneAt = 0;
export function installPhoneClickConversion() {
  if (phoneListener || typeof document === "undefined") return;
  phoneListener = true;
  document.addEventListener("click", (e) => {
    try {
      const a = e.target?.closest?.('a[href^="tel:"]');
      if (!a || !isPublicPath(window.location.pathname)) return;
      const now = Date.now();
      if (now - lastPhoneAt < 1000) return;
      lastPhoneAt = now;
      conversion("phone");
    } catch { /* never block the call */ }
  }, true);
}
